import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "id", "disabled", "pattern", "placeholder", "required", "maxlength", "minlength", "autocomplete", "data-1p-ignore"];
import { computed, ref, watch } from "vue";
import log from "../../services/Logger";
import { autocompleteAttr } from "./FormUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlText',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const model = ref(createModel());
        const fieldOptions = props.field.options || {};
        const inputType = computed(() => {
            return getInputType(props.field.type);
        });
        const autocomplete = computed(() => {
            return autocompleteAttr(fieldOptions);
        });
        function createModel() {
            if (typeof props.data === 'string' || props.data === null || props.data === undefined) {
                return props.data;
            }
            return "" + props.data;
        }
        // changes from the outside
        watch(() => props.data, () => model.value = createModel());
        // changes from the inside
        function onChange() {
            const value = model.value;
            log('FieldControlText@change', props.field.name, value);
            emit('change', value);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        function getInputType(type) {
            switch (type) {
                case 'text':
                    return 'text';
                case 'date':
                    return 'date';
                case 'datetime':
                    return 'datetime-local';
                case 'time':
                    return 'time';
                case 'email':
                    return 'email';
                case 'url':
                    return 'url';
                case 'password':
                    return 'password';
            }
            throw 'Unsupported field type: ' + type;
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                type: inputType.value ?? undefined,
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                pattern: _unref(fieldOptions).pattern ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                minlength: _unref(fieldOptions).minLength ?? undefined,
                autocomplete: autocomplete.value,
                "data-1p-ignore": _unref(fieldOptions).autocomplete === false ? true : undefined,
                class: _normalizeClass(["form__control", { 'form__control--empty': !model.value }])
            }, null, 42, _hoisted_1)), [
                [
                    _vModelDynamic,
                    model.value,
                    void 0,
                    { trim: true }
                ]
            ]);
        };
    }
});
